<template>
    <div id="fare-loading-modal" class="card" style="max-width: 800px; margin: 0 auto">
        <div class="card-body">
            <div class="container-modal-content pb-4">
                <h3>{{ $t('cars.search.loading.panelTitle') }}</h3>
                <b-progress :value="value" :max="100" animated class="mt-4 mb-4"></b-progress>
                <template v-if="canShowParams">
                    <div v-html="$t('cars.search.header.pickup', {
                        location: params.pickup_location.name,
                        date: window.moment(params.pickup_date).format($t('format.dateTimeLong')),
                        interpolation: {escape : false}
                    })"></div>
                    <div v-html="$t('cars.search.header.return', {
                        location: params.return_location.name,
                        date: window.moment(params.return_date).format($t('format.dateTimeLong')),
                        interpolation: {escape : false}
                    })"></div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'active',
            'params'
        ],
        data: function() {
            return {
                value: 0,
                minSpeed: 10,
                maxSpeed: 20,
            };
        },
        computed: {
            canShowParams: function() {
                return this.params
                    && this.params.pickup_location
                    && this.params.pickup_date
                    && this.params.return_location
                    && this.params.return_date;
            }
        },
        methods: {
            increment: function() {
                this.value += Math.floor(Math.random() * this.maxSpeed) + this.minSpeed;
            }
        },
        watch: {
            active: function(val) {
                if (val) {
                    this.interval = setInterval(this.increment, 1000);
                } else if (this.interval) {
                    clearInterval(this.interval);
                }
            }
        },
        mounted: function() {
            if (this.active) {
                this.interval = setInterval(this.increment, 1000);
            }
        }
    };
</script>

<style scoped>

</style>